export default "__VITE_ASSET__Ko61Eyx6__"